// The legacy getCustom endpoint defines brand names per seminar. Product names
// inherit the renamed brand while retaining their original variant suffix.
export function applyCustomNames(value, customs) {
  if (!Array.isArray(customs) || !customs.length) return value;
  const brands = new Map(customs.flatMap(company => (company.customBrands || [])
    .filter(brand => brand.brandName && brand.customBrandName)
    .map(brand => [brand.brandName, brand.customBrandName])));
  const companies = new Map(customs.filter(company => company.companyId != null && company.customCompanyName)
    .map(company => [String(company.companyId), company.customCompanyName]));
  const skuName = name => {
    if (typeof name !== 'string') return undefined;
    const divider = name.indexOf('_');
    if (divider < 1) return undefined;
    const custom = brands.get(name.slice(0, divider));
    return custom ? custom + name.slice(divider) : undefined;
  };
  const visit = item => {
    if (Array.isArray(item)) return item.map(visit);
    if (!item || typeof item !== 'object') return item;
    const named = Object.fromEntries(Object.entries(item).map(([key, child]) => [key, visit(child)]));
    const originalBrand = named.d_BrandName || named.brandName;
    const originalSku = named.d_SKUName || named.SKUName;
    const customBrand = brands.get(originalBrand);
    const customSku = skuName(originalSku);
    if (customBrand) named.customBrandName = customBrand;
    if (customSku) named.customSKUName = customSku;
    if (named.companyId != null && companies.has(String(named.companyId))) {
      named.customCompanyName = companies.get(String(named.companyId));
    }
    return named;
  };
  return visit(value);
}

export function customProductName(name, customs) {
  if (typeof name !== 'string' || !Array.isArray(customs)) return name;
  const divider = name.indexOf('_');
  if (divider < 1) return name;
  const brand = name.slice(0, divider);
  for (const company of customs) {
    const custom = company.customBrands?.find(item => item.brandName === brand)?.customBrandName;
    if (custom) return custom + name.slice(divider);
  }
  return name;
}
